import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DetalleState } from './detalle.reducers';
import * as fromDetalle from './detalle.reducers';

export const detalleState = createFeatureSelector<DetalleState>("detalle");


export const detalleSelected = createSelector(
	detalleState,
	state => state.detalle
)

export const detalleReady = createSelector(
	detalleState,
	state => state.ready
);